import { ReviewMasterPlanFormData } from 'types/dacum/reviewMasterplan';
import { create } from 'zustand';

type Mode = 'add' | 'edit' | 'view';

interface ReviewMasterplanState {
  formData: ReviewMasterPlanFormData;
  mode: Mode;
  setFormData: (_data: ReviewMasterPlanFormData) => void;
  setMode: (_data: Mode) => void;
  reset: () => void;
}

export const useReviewMasterplanStore = create<ReviewMasterplanState>((set) => ({
  formData: {},
  mode: 'add',
  setFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data }
    })),
  setMode: (data) => set(() => ({ mode: data })),
  reset: () =>
    set({
      formData: {},
      mode: 'add'
    })
}));
